import {format, parseISO} from "date-fns";

import {numberFormat, pluralize} from "@pg-mono/string-utils";

import {ILocationGenericSection, ParagraphType} from "../constants";
import {getDeliveryDateBuckets, getUpcomingDeliveryDate} from "../delivery_dates";

interface IProps {
    regionNameDeclensionWhere: string;
    offersCountForSale: number;
    offersCountReady: number;
    offersCountReadyInThreeMonths: number;
    offersCountReadyInSixMonths: number;
    offersCountReadyInOneYear: number;
    offerTypeNamePluralize: [string, string, string];
    offerTypeNameWithDeclensionOfReadyPluralize: [string, string, string];
    offersLatestConstructionDate: string | null;
}

export const getReadyOffersSectionTexts = (variables: IProps): ILocationGenericSection["paragraphs"] => {
    const getQuarterValue = (date: string) => {
        const quarter = Number(format(parseISO(date), "Q"));
        return ["I", "II", "III", "IV"][quarter - 1] || "";
    };

    const getYear = (date: string) => {
        return format(parseISO(date), "yyyy");
    };

    const deliveryBuckets = getDeliveryDateBuckets({
        countForSale: variables.offersCountForSale,
        countReady: variables.offersCountReady,
        countReadyInThreeMonths: variables.offersCountReadyInThreeMonths,
        countReadyInSixMonths: variables.offersCountReadyInSixMonths,
        countReadyInOneYear: variables.offersCountReadyInOneYear
    });
    const upcomingConstructionDate = getUpcomingDeliveryDate(variables.offersLatestConstructionDate);

    const getDeliveryBucketText = (count: number, deliveryTerm: string): string =>
        `${numberFormat(count)} ${pluralize(variables.offerTypeNameWithDeclensionOfReadyPluralize)(count)} ${deliveryTerm}. `;

    return [
        variables.offersCountReady > 0
            ? {
                  type: ParagraphType.TEXT,
                  text: [
                      `Obecnie deweloperzy ${variables.regionNameDeclensionWhere} oddali do użytku ${numberFormat(variables.offersCountReady)} ${pluralize(
                          variables.offerTypeNamePluralize
                      )(variables.offersCountReady)}. `,
                      deliveryBuckets.upToThreeMonths > 0 && getDeliveryBucketText(deliveryBuckets.upToThreeMonths, "do 3 miesięcy"),
                      deliveryBuckets.threeToSixMonths > 0 && getDeliveryBucketText(deliveryBuckets.threeToSixMonths, "od 3 do 6 miesięcy"),
                      deliveryBuckets.sixToTwelveMonths > 0 && getDeliveryBucketText(deliveryBuckets.sixToTwelveMonths, "od 6 do 12 miesięcy"),
                      deliveryBuckets.aboveOneYear > 0 && getDeliveryBucketText(deliveryBuckets.aboveOneYear, "w terminie powyżej roku")
                  ].filter(Boolean) as string[]
              }
            : {
                  type: ParagraphType.TEXT,
                  text: `Obecnie w ofercie deweloperów ${variables.regionNameDeclensionWhere} nie ma ${
                      variables.offerTypeNamePluralize[2]
                  } oddanych do użytku. ${
                      upcomingConstructionDate
                          ? `Najpóźniejszy termin oddania inwestycji ${variables.offerTypeNamePluralize[2]} do użytkowania to koniec ${getQuarterValue(
                                upcomingConstructionDate
                            )} kwartału ${getYear(upcomingConstructionDate)}.`
                          : ""
                  }`
              }
    ];
};
import {format, parseISO} from "date-fns";

import {numberFormat, pluralize} from "@pg-mono/string-utils";

import {ILocationGenericSection, ParagraphType} from "../constants";
import {getDeliveryDateBuckets, getUpcomingDeliveryDate} from "../delivery_dates";

interface IProps {
    regionNameDeclensionWhere: string;
    offersCountForSale: number;
    offersCountReady: number;
    offersCountReadyInThreeMonths: number;
    offersCountReadyInSixMonths: number;
    offersCountReadyInOneYear: number;
    offerTypeNamePluralize: [string, string, string];
    offerTypeNameWithDeclensionOfReadyPluralize: [string, string, string];
    offersLatestConstructionDate: string | null;
}

export const getReadyOffersSectionTexts = (variables: IProps): ILocationGenericSection["paragraphs"] => {
    const getQuarterValue = (date: string) => {
        const quarter = Number(format(parseISO(date), "Q"));
        return ["I", "II", "III", "IV"][quarter - 1] || "";
    };

    const getYear = (date: string) => {
        return format(parseISO(date), "yyyy");
    };

    const deliveryBuckets = getDeliveryDateBuckets({
        countForSale: variables.offersCountForSale,
        countReady: variables.offersCountReady,
        countReadyInThreeMonths: variables.offersCountReadyInThreeMonths,
        countReadyInSixMonths: variables.offersCountReadyInSixMonths,
        countReadyInOneYear: variables.offersCountReadyInOneYear
    });
    const upcomingConstructionDate = getUpcomingDeliveryDate(variables.offersLatestConstructionDate);

    const getDeliveryBucketText = (count: number, deliveryTerm: string): string =>
        `${numberFormat(count)} ${pluralize(variables.offerTypeNameWithDeclensionOfReadyPluralize)(count)} ${deliveryTerm}. `;

    return [
        variables.offersCountReady > 0
            ? {
                  type: ParagraphType.TEXT,
                  text: [
                      `Obecnie deweloperzy ${variables.regionNameDeclensionWhere} oddali do użytku ${numberFormat(variables.offersCountReady)} ${pluralize(
                          variables.offerTypeNamePluralize
                      )(variables.offersCountReady)}. `,
                      deliveryBuckets.upToThreeMonths > 0 && getDeliveryBucketText(deliveryBuckets.upToThreeMonths, "do 3 miesięcy"),
                      deliveryBuckets.threeToSixMonths > 0 && getDeliveryBucketText(deliveryBuckets.threeToSixMonths, "od 3 do 6 miesięcy"),
                      deliveryBuckets.sixToTwelveMonths > 0 && getDeliveryBucketText(deliveryBuckets.sixToTwelveMonths, "od 6 do 12 miesięcy"),
                      deliveryBuckets.aboveOneYear > 0 && getDeliveryBucketText(deliveryBuckets.aboveOneYear, "w terminie powyżej roku")
                  ].filter(Boolean) as string[]
              }
            : {
                  type: ParagraphType.TEXT,
                  text: `Obecnie w ofercie deweloperów ${variables.regionNameDeclensionWhere} nie ma ${
                      variables.offerTypeNamePluralize[2]
                  } oddanych do użytku. ${
                      upcomingConstructionDate
                          ? `Najpóźniejszy termin oddania inwestycji ${variables.offerTypeNamePluralize[2]} do użytkowania to koniec ${getQuarterValue(
                                upcomingConstructionDate
                            )} kwartału ${getYear(upcomingConstructionDate)}.`
                          : ""
                  }`
              }
    ];
};
